<template>

  <v-container
    v-if="contract && rooms && contract_types"
    :style="{width: '100%', maxWidth: '960px'}"
    ref="parent"
    fluid
  >

    <v-card outlined class="ma-2" style="margin-bottom: 58px !important;">
      <v-card-title v-once>
        {{contract.info.name || 'Create'}}
      </v-card-title>
      <v-divider class="mx-4"/>
      <v-card-text>
        <v-row no-gutters>

          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Contract</div>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="contract.info.contract_number" label="Numar" class="ma-1" outlined dense hide-details/>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="contract.info.name" label="Nume" class="ma-1" outlined dense hide-details/>
          </v-col>
          <v-col cols="12" md="4">
            <v-select v-model="contract.options.type" :items="contract_types" label="Tip" class="ma-1" outlined dense hide-details/>
          </v-col>
          <v-col cols="6">
            <v-menu v-model="menu_duration_start" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="contract.info.duration.start" v-on="on" label="De la" class="ma-1" readonly outlined dense hide-details/>
              </template>
              <v-date-picker v-model="contract.info.duration.start" @input="menu_duration_start = false"/>
            </v-menu>
          </v-col>
          <v-col cols="6">
            <v-menu v-model="menu_duration_stop" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="contract.info.duration.stop" v-on="on" label="Pana la" class="ma-1" readonly outlined dense hide-details/>
              </template>
              <v-date-picker v-model="contract.info.duration.stop" @input="menu_duration_stop = false"/>
            </v-menu>
          </v-col>

          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Contractor</div>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="contract.info.signing_agent" label="Nume" class="ma-1" outlined dense hide-details/>
          </v-col>
          <v-col cols="12" md="6">
            <v-menu v-model="menu_signing_date" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="contract.info.signing_date" v-on="on" label="Data semnării" class="ma-1" readonly outlined dense hide-details/>
              </template>
              <v-date-picker v-model="contract.info.signing_date" @input="menu_signing_date = false"/>
            </v-menu>
          </v-col>

          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Camere</div>
          </v-col>
          <v-col cols="12" v-for="(room, index) in contract.options.rooms" :key="`room_${index}`">
            <v-card class="ma-1" outlined>
              <v-card-text class="pa-1">
                <v-row no-gutters>
                  <v-col cols="12" md="11">
                    <v-row no-gutters>
                      <v-col cols="12" md="6">
                        <v-select v-model="room.room_type_id" class="ma-1" label="Camera" :items="rooms" outlined dense hide-details/>
                      </v-col>
                      <v-col cols="4" md="2">
                        <v-text-field v-model="room.price" class="ma-1" type="number" label="Pret" outlined dense hide-details/>
                      </v-col>
                      <v-col cols="4" md="2">
                        <v-text-field v-model="room.release" class="ma-1" type="number" label="Release" outlined dense hide-details/>
                      </v-col>
                      <v-col cols="4" md="2">
                        <v-text-field v-model="room.inventory" class="ma-1" type="number" label="Inventar" outlined dense hide-details/>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="1">
                    <v-row no-gutters>
                      <v-col cols="12">
                        <div class="ma-1">
                          <v-btn height="40" color="delete white--text" block depressed @click="removeRoom(room)">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" class="text-right">
            <v-btn dark color="create" depressed class="ma-1" @click="addRoom">
              <v-icon left>mdi-plus</v-icon>
              Adaugă
            </v-btn>
          </v-col>

          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Termeni de Plată</div>
          </v-col>
          <v-col cols="12" v-for="(installment, index) in contract.options.installments" :key="`installment_${index}`">
            <v-card class="ma-1" outlined>
              <v-card-text class="pa-1">
                <v-row no-gutters>
                  <v-col cols="12" md="11">
                    <v-row no-gutters>
                      <v-col cols="12" md="6">
                        <v-menu v-model="installment.menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="installment.due" v-on="on" label="Dată" class="ma-1" readonly outlined dense hide-details/>
                          </template>
                          <v-date-picker v-model="installment.due" @input="installment.menu = false"/>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field v-model="installment.value" class="ma-1" type="number" label="Valoare" outlined dense hide-details/>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="1">
                    <div class="ma-1">
                      <v-btn height="40" color="delete white--text" depressed block @click="removeInstallment(installment)">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" class="text-right">
            <v-btn dark color="create" depressed class="ma-1" @click="addInstallment">
              <v-icon left>mdi-plus</v-icon>
              Adaugă
            </v-btn>
          </v-col>


          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Fișiere</div>
          </v-col>
          <v-col cols="12">
            <v-file-input v-model="files" accept="application/pdf" label="Adăuga" class="ma-1" @change="onFileChange($event)" multiple small-chips show-size outlined dense hide-details/>
          </v-col>
          <v-col cols="12" v-for="(file, index) in files_64" :key="`file_${index}`">
            <v-card class="ma-1" outlined>
              <v-card-text class="pa-1">
                <v-row no-gutters align="center">
                  <v-col cols="11">
                    <v-text-field v-model="file.name" label="Nume" class="ma-1" outlined dense hide-details/>
                  </v-col>
                  <v-col cols="1">
                    <div class="ma-1">
                      <v-btn height="40" color="delete white--text" depressed block @click="removeFile(file)">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" v-for="(file, index) in contract.files" :key="`contract_${index}`">
            <v-card class="ma-1" outlined>
              <v-card-text class="pa-1">
                <v-row no-gutters align="center">
                  <v-col cols="10">
                    <v-text-field v-model="file.properties.name" label="Nume" class="ma-1" outlined dense hide-details readonly/>
                  </v-col>
                  <v-col cols="1">
                    <div class="ma-1">
                      <v-btn height="40" color="primary" :href="file.url" target="_blank" dark depressed block>
                        <v-icon>
                          mdi-download
                        </v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                  <v-col cols="1">
                    <div class="ma-1">
                      <v-btn height="40" color="delete white--text" depressed block @click="destroyFile(file, index)" :loading="file_loading[index]" :disabled="file_loading[index]">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>


        </v-row>

      </v-card-text>

    </v-card>

    <v-card outlined v-resize="onResize" :width="dynamic_width" class="ma-2" :style="{position: 'fixed', bottom: 0, maxWidth: '960px'}">
      <v-card-actions>
        <v-btn v-if="contract.id" depressed color="delete white--text" @click="destroy" :loading="deleting" :disabled="deleting">
          <v-icon left>mdi-delete</v-icon>
          Șterge
        </v-btn>
        <v-spacer/>
        <v-btn depressed color="primary white--text" @click="save" :loading="saving" :disabled="saving">
          <v-icon left>mdi-floppy</v-icon>
          Salvează
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-container>

  <v-container v-else fluid class="fill-height">
    <v-row align="center" justify="center">
      <v-progress-circular indeterminate color="primary"/>
    </v-row>
  </v-container>

</template>

<script>

  import default_contract from "@/defaults/default-contract";
  import contract_repository from '@/repositories/contract-repository';
  import config_repository from '@/repositories/config-repository';
  import room_repository from "@/repositories/room-repository";
  import media_repository from "@/repositories/media-repository";

  export default {
    data: () => ({
      contract: null,
      contract_types: null,
      rooms: null,

      menu_duration_start: false,
      menu_duration_stop: false,
      menu_signing_date: false,

      files: null,
      files_64: null,
      file_loading: [],

      saving: false,
      deleting: false,


      dynamic_width: 0
    }),

    async created() {
      this.contract = this.$route.params.contract === 'create' ? _.cloneDeep(default_contract) : await contract_repository.getContract(this.$route.params.contract);
      this.contract_types = await config_repository.getContractTypes();
      this.rooms = await room_repository.getRooms(this.$route.params.hotel, {size: 1000, page: 1});
      this.rooms = this.rooms.data.map(room => ({text: room.name, value: room.id}))
    },

    methods: {
      async save() {
        try {
          this.saving = true;
          if (this.$route.params.contract === 'create') {
            this.contract.hotel_id = Number(this.$route.params.hotel);
            this.contract = await contract_repository.saveContract(this.contract);
            await media_repository.saveMedia(this.contract.id, 'contracts', {files: this.files_64});
            await this.$router.push(`/hotels/${this.$route.params.hotel}/contracts/${this.contract.id}`);
          } else {
            await media_repository.saveMedia(this.contract.id, 'contracts', {files: this.files_64});
            this.contract = await contract_repository.saveContract(this.contract);
          }
          await this.$store.dispatch('alert/success', 'Success');
        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.saving = false;
          this.files = null;
          this.files_64 = null;
        }
      },

      async destroy() {
        try {
          this.deleting = true;
          this.contract.files.forEach(file => { media_repository.deleteMedia(this.contract.id,'contracts', file); });
          await contract_repository.destroyContract(this.$route.params.hotel, this.contract.id);
          await this.$router.push(`/hotels/${this.$route.params.hotel}/contracts`);
          await this.$store.dispatch('alert/success', 'Success');
        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.deleting = false;
        }
      },

      addRoom() {
        this.contract.options.rooms.push({
          room_type_id: null,
          price: null,
          release: null,
          inventory: null
        });
      },

      removeRoom(room) {
        this.contract.options.rooms.splice(this.contract.options.rooms.indexOf(room), 1);
      },

      addInstallment() {
        this.contract.options.installments.push({
          due: null,
          value: null
        });
      },

      removeInstallment(installment) {
        this.contract.options.installments.splice(this.contract.options.installments.indexOf(installment), 1);
      },

      removeFile(file) {
        this.files.splice(this.files.indexOf(file), 1);
        this.files_64.splice(this.files_64.indexOf(file), 1);
      },

      async destroyFile(file, index) {
        try {
          this.$set(this.file_loading, index, true);
          await media_repository.deleteMedia(this.contract.id, 'contracts', file);
          this.contract = await contract_repository.getContract(this.$route.params.hotel, this.$route.params.contract);
          await this.$store.dispatch('alert/success', 'Documentul a fost sters!')
        } catch (e) {
          await this.$store.dispatch('alert/error', e)
        } finally {
          this.$set(this.file_loading, index, false);
        }
      },

      onFileChange(files) {
        this.files_64 = [];
        for (let file of files) {
          const fileReader = new FileReader();
          fileReader.addEventListener('load', () => {
            this.files_64.push({
              data: fileReader.result,
              name: file.name
            });
          });
          fileReader.readAsDataURL(file);
        }
      },

      onResize() {
        this.dynamic_width = this.$refs['parent'].clientWidth - 40;
      }

    }


  }

</script>